module.exports = __webpack_public_path__ + "static/media/CL 18 text.01e2888e.mp3";